import script from "./Page.vue?vue&type=script&setup=true&lang=ts"
export * from "./Page.vue?vue&type=script&setup=true&lang=ts"

import "./Page.vue?vue&type=style&index=0&id=13c15a47&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c15a47"]])

export default __exports__